<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate >
  <app-ag-grid class="mt-3" [gridOptions]="notesGridOptions" [rowData]="notes">
  </app-ag-grid>
  <ng-template #buttonsCell let-row>
    <button pButton type="button" class="p-button-text p-button-sm" (click)="deleteNote(row)">Del</button>
  </ng-template>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-3">
    <button  pButton type="button" class="p-button-raised" (click)="addNote()">Add Note</button>
    <button  pButton type="button" class="p-button-raised" 
       *ngIf="!this.isEditingAllowed" (click)="allowEditing()">Allow Editing
    </button>
    <button  pButton type="button" class="p-button-raised" 
       *ngIf="this.isEditingAllowed" (click)="disallowEditing()">Disallow Editing
    </button>
    <button  pButton type="button" class="p-button-raised" icon="pi pi-check"
      [disabled]="!uow.hasChanges()" (click)="save()">Save & Exit
    </button>
    <button  pButton type="button" class="p-button-raised" 
      [disabled]="!uow.hasChanges()" (click)="undo(false)">Undo Changes
    </button>
    <button  pButton type="button" class="p-button-raised" 
      (click)="undo(true)">Cancel
    </button>
  </div>

</ng-template>
